import { render, staticRenderFns } from "./doctor_detail.vue?vue&type=template&id=f55f8498&scoped=true&"
import script from "./doctor_detail.vue?vue&type=script&lang=js&"
export * from "./doctor_detail.vue?vue&type=script&lang=js&"
import style0 from "./doctor_detail.vue?vue&type=style&index=0&id=f55f8498&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55f8498",
  null
  
)

export default component.exports